//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Particles from "./components/Particles";

export default {
  name: "WelcomePage",
  components: {
    Particles
  },
  data() {
    return {
      userInfo: {
        name: "",
        department: "",
      },
      particlesStatus: true
    };
  },
  methods: {
    getUserInfo() {
      let user = this.$store.getters.userInfo;
      this.userInfo.name = user.userName;
      this.userInfo.department = user.department;
    },
  },
  mounted() {
    this.getUserInfo();
  },
  beforeMount() {
    if (localStorage.getItem("particles") == null) {
      localStorage.setItem("particles", "true");
    }
    localStorage.getItem("particles") === "true" ? this.particlesStatus = true : this.particlesStatus = false
  },
};
